<template>
  <a-card :bordered='false' class='main_box' size='small'>
    <div class='table-operator'>
      <a-form layout="inline">
      <a-row :gutter="24">
          <a-col :span="8">
      <a-radio-group v-model="baseQueryParam.type" @change="searchQuery">
        <a-radio-button value="1">
          系统质疑
        </a-radio-button>
        <a-radio-button value="2">
          终止随访
        </a-radio-button>        
      </a-radio-group>
          </a-col>
      <a-col :span="16" style="text-align: left">
            <a-form-item label="表单名称" >
              <a-input placeholder="请输入名称" v-model="queryParam.formName" ></a-input>
            </a-form-item>          
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
      <a-button icon='plus' style="margin-left: 20px" type='primary' @click='handleAddMy()'>新增</a-button>
      <!-- <a-button icon='plus' type='primary' @click='handleAddExist()'  style="margin-left: 8px">复制已有</a-button> -->
          </a-col>
      </a-row>
      </a-form>
    </div>
    <div>
      <a-table :columns='columns'
               :dataSource='dataSource'
               :loading='loading'
               :pagination='ipagination'
               rowKey='id'
               size='small'
               @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
         <a-button size='small' type='primary' @click='handleStop(record.id , record.status==="1"?"0":"1")'>{{record.status==='1'?'停用':'启用'}}</a-button>
         <a-divider type='vertical' />
           <a-button size='small' type='primary' @click='handleEdit(record)'>编辑</a-button>
         <a-divider type='vertical' />
          <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
            <a-button size='small' type='danger'>删除</a-button>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <sys-question-model ref="modalForm" @ok="modalFormOk" ></sys-question-model>
    <add-exist ref="addExist" @handleSelect="addExistSelect" :type="baseQueryParam.type"></add-exist>
  </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysQuestionModel from '@views/tempconfig/sysQuestion/SysQuestionModel'  
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  import AddExist from './sysQuestion/addexist/AddExist'
  export default {
    name: 'TempConfigQuestion',
    components: { SysQuestionModel,AddExist },
    mixins: [JeecgListMixin],
    data() {
      return {
        url: {
          list: '/tempconfig/question/list',
          delete: '/tempconfig/question/delete',
        },
        // projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        disableMixinCreated: true
      }
    },
    computed: {
      columns() {
        return [
          {
            title: '#',
            align: 'center',
            width: 80,
            customRender: (text, record, index) => index + 1
          },
          {
            title: '质疑表单',
            dataIndex: 'formName',
            width: 200,
            ellipsis: true
          },
          {
            title: '质疑元素',
            dataIndex: 'formItemName',
            width: 200,
            ellipsis: true
          },
          {
            title: '周期',
            dataIndex: 'periodType',
            width: 200,
            ellipsis: true,
            customRender:(text,record)=>{
              if(text ==='1'){
                return '所有周期'
              }else{
                return record.periodItemName
              }
            }
          },
          {
            title: '质疑说明',
            dataIndex: 'description',
            ellipsis: true
          },
          {
          title: '提交人',
          width: 90,
          dataIndex: 'updateBy',
          ellipsis: true,
          customRender: (text, record) => text || record.createBy,
        },
        {
          title: '提交时间',
          width: 150,
          dataIndex: 'updateTime',
          ellipsis: true,
          customRender: (text, record) => text || record.createTime,
        },
          {
            title: '操作',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ]
      }
    },
    created() {
      this.baseQueryParam = {
        // projectId:this.projectId,
        type:'1'
      }
      this.loadData()
    },

    methods: {
      addExistSelect(record){
      postAction('/project/projectSysQuestion/copyByExist',{
        // projectId:this.projectId,
        existId:record.id
      }).then(res=>{
        if(res.success){
          this.$message.success(res.message)
          this.loadData()
        }else{
          this.$message.error(res.message)
        }
      })
    },

      /**
       * 停用
       */
      handleStop(id,status) {
        postAction('/tempconfig/question/editStatus',{id:id,status:status}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      handleAddMy(){
        this.handleEdit({
          type:this.baseQueryParam.type
        })
      },
      handleAddExist(){
        this.$refs.addExist.open()
      },
    }

  }
</script>

<style scoped lang="less">
@import '~@/assets/less/common.less';
</style>
